'use client'

import { TonConnectUIProvider } from '@tonconnect/ui-react'
import { ReactNode } from 'react'

interface TonProviderProps {
    children: ReactNode
}

/**
 * TON Connect Provider
 * Wraps the app with TonConnectUIProvider for wallet connectivity
 */
export function TonProvider({ children }: TonProviderProps) {
    // Always use the production domain for the manifest URL.
    // When testing via ngrok, window.location.origin points to the ngrok URL,
    // but ngrok's free tier interstitial blocks TON wallets from fetching the manifest.
    // The production URL is always accessible and serves the correct JSON.
    const manifestUrl = process.env.NEXT_PUBLIC_APP_URL
        ? `${process.env.NEXT_PUBLIC_APP_URL}/tonconnect-manifest.json`
        : 'https://tokenkickstarter.com/tonconnect-manifest.json'

    return (
        <TonConnectUIProvider manifestUrl={manifestUrl}>
            {children}
        </TonConnectUIProvider>
    )
}
